import { atom } from 'recoil';

//状態管理
export const webcamAtom = atom({
  key: 'webcamAtom',
  default:
    localStorage.getItem('mode') != null && localStorage.getItem('mode') === 'facial'
      ? true
      : false,
});

export const dailyStateAtom = atom({
  key: 'dailyStateAtom',
  default: 'STATE_IDLE',
});

export const mouthShapeAtom = atom({
  key: 'mouthShapeAtom',
  default: 0,
});

export const takePictureAtom = atom({
  key: 'takePictureAtom',
  default: false,
});

export const pageAtom = atom({
  key: 'pageAtom',
  default: 'main',
});

export const nftDetailAtom = atom({
  key: 'nftDetailAtom',
  default: {
    show: false,
    isMe: false,
    displayName: null,
    userID: null,
    nftID: null,
    nftWhoCanUse: 'anyone',
  },
});

export const myNftAtom = atom({
  key: 'myNftAtom',
  default: null,
});

export const myNftBackAtom = atom({
  key: 'myNftBackAtom',
  //default: '',
  default: null,
});

export const metaMaskAtom = atom({
  key: 'metaMaskAtom',
  default: null,
});

export const isAuthAtom = atom({
  key: 'isAuthAtom',
  default: false,
});

export const userTypeAtom = atom({
  key: 'userTypeAtom',
  default: 'speaker',
});

export const isAuthLoadedAtom = atom({
  key: 'isAuthLoadedAtom',
  default: false,
});

export const sessionUsersAtom = atom({
  key: 'sessionUsersAtom',
  default: {},
});

export const topMessageAtom = atom({
  key: 'topMessageAtom',
  default: null,
});

export const myFaceAtom = atom({
  key: 'myFaceAtom',
  default: [0, 0, 0, 0, 0],
});

export const displayNameAtom = atom({
  key: 'displayNameAtom',
  default: '',
});

export const isFaceDetectReadyAtom = atom({
  key: 'isFaceDetectReadyAtom',
  default: false,
});

export const myMediaStreamAtom = atom({
  key: 'myMediaStreamAtom',
  default: null,
});

export const cameraInputAtom = atom({
  key: 'cameraInputAtom',
  default: '',
});

export const micInputAtom = atom({
  key: 'micInputAtom',
  default: '',
});

export const twitterAtom = atom({
  key: 'twitterAtom',
  default: '',
});

export const nftIDAtom = atom({
  key: 'nftIDAtom',
  default: {},
});

export const playSoundAtom = atom({
  key: 'playSoundAtom',
  default: null,
});

export const screenShareAtom = atom({
  key: 'screenShareAtom',
  default: null,
});

export const remoteUsersAtom = atom({
  key: 'remoteUsersAtom',
  default: null,
});

export const recordLocalAtom = atom({
  key: 'recordLocalAtom',
  default: false,
});

export const reactionAtom = atom({
  key: 'reactionAtom',
  default: {},
});

export const tapCameraAtom = atom({
  key: 'tapCameraAtom',
  default: false,
});

export const myMuteAtom = atom({
  key: 'myMuteAtom',
  default: false,
});

export const playAudioAtom = atom({
  key: 'playAudioAtom',
  default: false,
});

export const authUserTypeAtom = atom({
  key: 'authUserTypeAtom',
  default: null,
});

export const recordTypeAtom = atom({
  key: 'recordType',
  default: 'local',
});

export const avatarSizeAtom = atom({
  key: 'avatarSizeAtom',
  default: 'size2',
});

export const screenShareSelectAtom = atom({
  key: 'screenShareSelectAtom',
  default: null,
});

export const showEditNameAtom = atom({
  key: 'showEditNameAtom',
  default: false,
});

export const customAvatarAtom = atom({
  key: 'customAvatarAtom',
  default: {},
});

export const BGMAtom = atom({
  key: 'BGMAtom',
  default: null,
});

export const BGMVolumeAtom = atom({
  key: 'BGMVolumeAtom',
  default: 30,
});

export const isTextToSpeechAtom = atom({
  key: 'isTextToSpeechAtom',
  default: false,
});
